import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";

function MainNavbar() {
  const handleLogoClick = () => {
    window.location.reload();// This triggers a page reload
  };
  return (
    <>
      <Navbar
        style={{
          border: " solid #ccc",

          padding: "0px 2px 2px 2px" /* Add 10px of padding */,

          backgroundColor:
            "rgba(255, 255, 255, 0.9)" /* Add a 90% opaque white background */,

          borderRadius: "0 0 0px 0px" /* Add a 10px border radius */,

          boxShadow:
            "0px 0px 5px rgba(0, 0, 0, 0.3)" /* Add a 10px shadow with 30% opacity */,
        }}
      >
        <Container>
          <Navbar.Brand href="#" onClick={handleLogoClick}>
            <img
              alt=""
              src="https://nwow.brillio.com/assets/images/boltlogo.png"
              width="120"
              height="35"
              className="d-inline-block align-top float-left"
            />{" "}
          </Navbar.Brand>

          <Navbar.Text
            style={{
              color: "black",
              alignContent: "center",
              marginRight: "37%",
            }}
          >
            
          </Navbar.Text>
        </Container>
       
      </Navbar>
    </>
  );
}

export default MainNavbar;
